import React from "react";
import PropTypes from "prop-types";
import awardsData from "./Awards.data";

const AwardsSection = () => (
  <section className="card" aria-label="Awards section">
    <div>
      <div className="text-center">
        <h3>Awards</h3>
      </div>
      {awardsData.map((award, index) => (
        <div key={index} className="card">
          {typeof award === "string" ? (
            <p>{award}</p>
          ) : (
            <article>
              <p>
                {award.text}
                <div className="column">
                  {award.links?.map((link, linkIndex) => (
                    <a
                      key={linkIndex}
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={link.text || `External link ${linkIndex + 1}`}
                    >
                      {link.icon ? <i className={link.icon} aria-hidden="true"></i> : link.text}
                    </a>
                  ))}
                </div>
              </p>
            </article>
          )}
        </div>
      ))}
    </div>
  </section>
);

AwardsSection.propTypes = {};

export default AwardsSection;
